import React, { useEffect } from "react";
import {
  FaChartLine,
  FaHeartbeat,
  FaCreditCard,
  FaCheck,
} from "react-icons/fa";
import "./Portfolio.css";

import leadManagementImage from "../assets/lead-management.png";
import healthcareImage from "../assets/healthcare-management.png";
import paymentImage from "../assets/payment-orchestrator.png";

const Portfolio = () => {
  useEffect(() => {
    const animatedElements = document.querySelectorAll(".portfolio-animate");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("portfolio-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
      },
    );

    animatedElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

useEffect(() => {
  if (window.location.hash === "#featured-projects") {
    const timer = setTimeout(() => {
      const section = document.getElementById("featured-projects");

      section?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300);

    return () => clearTimeout(timer);
  }
}, []);


  const projectImages = {
    leadManagement: leadManagementImage,
    healthcare: healthcareImage,
    payment: paymentImage,
  };
  const projects = [
    {
      icon: <FaChartLine />,
      title: "Lead Management System",
      category: "Enterprise Software",
      description:
        "A comprehensive solution for managing leads, tracking interactions, assigning ownership and streamlining follow-up processes.",
      image: projectImages.leadManagement,
      features: [
        "Lead tracking and management",
        "Lead assignment and collaboration",
        "Follow-up management",
        "Reports and analytics",
      ],
    },
    {
      icon: <FaHeartbeat />,
      title: "Healthcare Management System",
      category: "Healthcare Solution",
      description:
        "A digital solution designed to streamline healthcare operations, patient management and organizational workflows.",
      image: projectImages.healthcare,
      features: [
        "Patient management",
        "Healthcare workflow management",
        "Organizational management",
        "Secure digital records",
      ],
    },
    {
      icon: <FaCreditCard />,
      title: "Payment Orchestrator",
      category: "FinTech Solution",
      description:
        "A centralized solution designed to simplify payment processing and manage multiple payment integrations.",
      image: projectImages.payment,
      features: [
        "Payment integration",
        "Transaction management",
        "Payment workflow",
        "Secure processing",
      ],
    },
  ];

  return (
    <div className="portfolio-page">
      {/* =================================================
          PORTFOLIO HERO
      ================================================= */}

      <section className="portfolio-hero">
        <div className="portfolio-hero-bg"></div>

        <div className="portfolio-hero-container">
          <div className="portfolio-hero-content portfolio-animate">
            <span className="portfolio-label">OUR PORTFOLIO</span>

            <h1>
              Building Solutions
              <br />
              That <span>Create Impact</span>
            </h1>

            <p>
              Explore our key products and digital solutions designed to solve
              real-world business challenges and create lasting value.
            </p>
          </div>

          {/* <div className="portfolio-hero-visual">

            <div className="portfolio-device">

              <div className="device-screen">

                <div className="screen-header"></div>

                <div className="screen-content">

                  <div className="screen-chart">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>

                  <div className="screen-box"></div>

                  <div className="screen-box small"></div>

                </div>

              </div>

              <div className="device-base"></div>

            </div>

            <div className="portfolio-floating-icon icon-one">
              <FaChartLine />
            </div>

            <div className="portfolio-floating-icon icon-two">
              <FaCreditCard />
            </div>

            <div className="portfolio-floating-icon icon-three">
              <FaHeartbeat />
            </div>

          </div> */}
        </div>
      </section>

      {/* =================================================
          FEATURED PROJECTS
      ================================================= */}

      <section id="featured-projects" className="portfolio-projects-section">
        <div className="portfolio-projects-container">
          <div className="portfolio-section-header portfolio-animate">
            <span className="portfolio-section-label">FEATURED PROJECTS</span>

            <h2>
              Our Key <span>Projects</span>
            </h2>

            <p>
              We build scalable, secure and user-friendly solutions that help
              businesses work smarter and operate more efficiently.
            </p>
          </div>

          <div className="portfolio-project-grid">
            {projects.map((project, index) => (
              <article
                className={`portfolio-project-card portfolio-animate portfolio-card-${index + 1}`}
                key={index}
              >
                <div className="portfolio-project-image">
                  <img src={project.image} alt={project.title} />

                  <div className="portfolio-project-icon">{project.icon}</div>
                </div>

                <div className="portfolio-project-content">
                  <span className="portfolio-project-category">
                    {project.category}
                  </span>

                  <h3>{project.title}</h3>

                  <p>{project.description}</p>

                  <ul className="portfolio-project-features">
                    {project.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <FaCheck />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
